<template>
	<transition name="slide-fade">
		<div class="mb-5 pb-5">
			<h2 class="tw-font-semibold tw-text-xl tw-text-gray-800 tw-leading-tight text-center">Profile</h2>
			<div class="tw-max-w-7xl tw-mx-auto sm:tw-px-6 lg:tw-px-8">
				<update-profile-information-form :user="$page.props.user" />
				<update-password-form class="tw-mt-10 sm:tw-mt-0" />
				<div v-if="$page.props.jetstream.canManageTwoFactorAuthentication">
					<two-factor-authentication-form class="tw-mt-10 sm:tw-mt-0" />
				</div>
				<can-fast-login :user="user" v-show="true" class=""></can-fast-login>
				<referral-code :user="user" :errors="errors"></referral-code>
				<logout-other-browser-sessions-form :sessions="sessions" class="tw-mt-10 sm:tw-mt-0" />
				<delete-user-form class="tw-mt-10 sm:tw-mt-0" :user="user" />
				<span class="hidden">
					<v-btn @click="registerurl()" class="">Register URL</v-btn>
					<v-btn @click="stkpush()" class="">StkPush</v-btn>
					<v-btn @click="testmpesa()" class="">Access Token</v-btn>
				</span>
			</div>
		</div>
	</transition>
</template>

<script>
	import AppLayout from '@/Layouts/User'
	const DeleteUserForm = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "user-profile" */ './DeleteUserForm')
	const CanFastLogin = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "user-profile" */ '@/Pages/Profile/FastLogin')
	const UpdatePasswordForm = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "user-profile" */ './MkUpdatePasswordForm')
	const JetSectionBorder = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "user-profile" */ '@/Jetstream/SectionBorder')
	const TwoFactorAuthenticationForm = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "user-profile" */ './TwoFactorAuthenticationForm')
	const UpdateProfileInformationForm = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "user-profile" */ './UpdateProfileInformationForm')
	const LogoutOtherBrowserSessionsForm = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "user-profile" */ './LogoutOtherBrowserSessionsForm')
	const ReferralCode = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "user-profile" */  './ReferralCode')

	export default {
		props: [
			'sessions',
			'user',
			'errors'
		],
		layout: AppLayout,
		components: {
			AppLayout,
			DeleteUserForm,
			CanFastLogin,
			ReferralCode,
			JetSectionBorder,
			LogoutOtherBrowserSessionsForm,
			TwoFactorAuthenticationForm,
			UpdatePasswordForm,
			UpdateProfileInformationForm,
		},

		metaInfo () {
			return {
				title: 'User Profile',
				titleTemplate: '%s | ' + this.$title
			}
		},
		methods: {
			testmpesa () {
				axios.get('/mpesa/access_token')
			},
			registerurl () {
				axios.get('/mpesa/callback/register')
			},
			stkpush () {
				axios.post('/mpesa/lipa', {
					phone: '254729719467',
					amount: 2,
					account: 'Test'
				})
			}
		}
	}
</script>
